var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_3038232",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 63.43-23.08 121.48-61.29 166.2-10.715 12.55-31.673 2.128-44.6 12.399-9.477 7.53-10.451 36.319-20.95 42.461-37.92 22.21-82.05 34.94-129.16 34.94-110.36 0-204.41-69.83-240.36-167.72-4.93-13.4 24.864-27.33 22.224-41.68-2.27-12.36-10.988-25.02-11.418-37.92-.08-2.18.02-4.37 0-6.56-.01-.71-.01-1.41-.01-2.12 0-4.07-26.335-8.12-26.145-12.15 6.339-135.74 118.399-243.85 255.709-243.85 141.38 0 256 114.62 256 256z",
    fill: "#9dc6fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.55 291.49-56.84 86.26c-12.01 18.25-35.66 24.81-55.36 15.36l-101.81-48.83h-7.9c-9.89-26.89-15.39-55.9-15.63-86.16h119.43z",
    fill: "#ffddce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.443 298.772v-3.469h88.589v29.182h-62.875c-14.202 0-25.714-11.512-25.714-25.713z",
    fill: "#ffcbbe"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m450.8 293.42v125.61c0 1.06-.03 2.12-.09 3.17-18.57 21.75-40.73 40.34-65.55 54.86-28.91-3.54-51.29-28.17-51.29-58.03 0 32.29-26.18 58.47-58.47 58.47-16.14 0-30.76-6.54-41.34-17.13-10.58-10.58-17.12-25.19-17.12-41.34v-125.61z",
    fill: "#986b54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.229 470.989c-5.394-2.754-10.286-6.349-14.542-10.605-10.582-10.582-17.113-25.192-17.113-41.35v-125.62h-53.639v125.62c0 16.158 6.554 30.768 17.113 41.35 10.582 10.582 25.215 17.113 41.35 17.113 9.672.001 18.798-2.343 26.831-6.508z",
    fill: "#845c47"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m450.8 293.423v91.5c-17.35 9.76-37.37 15.33-58.69 15.33h-116.48c-21.32 0-41.34-5.57-58.69-15.33v-91.5z",
    fill: "#845c47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.106 145.67h-116.475c-66.216 0-119.894 53.678-119.894 119.894 0 66.216 53.678 119.894 119.894 119.894h116.475c66.216 0 119.894-53.678 119.894-119.894 0-66.216-53.678-119.894-119.894-119.894z",
    fill: "#986b54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452 265.56c0 25.03-15.43 46.53-37.28 55.46-6.25 2.56-13.02 4.1-20.11 4.38-.83.04-1.66.06-2.5.06h-116.48c-33.02 0-59.89-26.87-59.89-59.9 0-33.02 26.87-59.89 59.89-59.89h116.48c33.02 0 59.89 26.87 59.89 59.89z",
    fill: "#845c47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m259.18 269.94c.01 18.03-14.63 32.66-32.65 32.65l-222.3.01c-2.27-12.36-3.65-25.02-4.08-37.92-.08-2.18-.12-4.37-.14-6.56-.01-.71-.01-1.41-.01-2.12 0-4.07.1-8.12.29-12.15h35.77l14.35-14.89c27.96-29.02 73.55-31.59 104.6-5.92l17.22 14.25h54.29c9.02 0 17.18 3.65 23.09 9.56s9.57 14.08 9.57 23.09z",
    fill: "#ffddce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.18 269.94c0 3.65-.59 7.15-1.69 10.42-1.62-4.82-4.35-9.15-7.87-12.67-5.91-5.91-14.08-9.56-23.09-9.56h-54.3l-1.26-1.06c-40.05-33.12-98.85-29.79-134.91 7.61h-35.91c-.08-2.18-.12-4.37-.14-6.56-.01-.71-.01-1.41-.01-2.12 0-4.07.1-8.12.29-12.15h35.77l14.35-14.89c27.96-29.02 73.55-31.59 104.6-5.92l17.22 14.25h54.29c9.02 0 17.18 3.65 23.09 9.56s9.58 14.06 9.57 23.09z",
    fill: "#ffcbbe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 270.221,
    cy: 184.115,
    fill: "#ffd064",
    r: 53.286
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.221,
    cy: 184.115,
    fill: "#ebb044",
    r: 32.832
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 382.321,
    cy: 77.542,
    fill: "#ffd064",
    r: 53.286
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.321,
    cy: 77.542,
    fill: "#ebb044",
    r: 32.832
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m414.72 321.02c-6.25 2.56-13.02 4.1-20.11 4.38-.83.04-1.66.06-2.5.06h-83.48c1.21-28.36 24.59-50.98 53.24-50.98 27.14 0 49.54 20.3 52.85 46.54z",
    fill: "#ffd064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.61 325.4c-.83.04-1.66.06-2.5.06h-62.99c1.18-17.06 15.39-30.53 32.75-30.53 17.33 0 31.53 13.44 32.74 30.47z",
    fill: "#ebb044"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m267.857 130.638h-15.435v-15.435c0-8.302-6.73-15.032-15.032-15.032-8.302 0-15.032 6.73-15.032 15.032v15.435h-15.435c-8.302 0-15.032 6.73-15.032 15.032s6.73 15.032 15.032 15.032h15.435v15.435c0 8.302 6.73 15.032 15.032 15.032 8.302 0 15.032-6.73 15.032-15.032v-15.435h15.435c8.302 0 15.032-6.73 15.032-15.032s-6.73-15.032-15.032-15.032z",
    fill: "#f9f6f6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestTransfer);
export default __webpack_public_path__ + "static/media/request-transfer.d67ac97272e93e3b798ec784a3d2da51.svg";
export { ForwardRef as ReactComponent };